import { supabase, isSupabaseConfigured } from "./supabaseClient";

const DEMO_SESSION_KEY = "vrfood_demo_admin_session";
// Demo-mode-only fallback so the dashboard is usable with zero setup. This
// path never runs once Supabase is configured (see isSupabaseConfigured),
// so it never ships as the real auth for the live site.
const DEMO_PASSWORD = process.env.REACT_APP_DEMO_ADMIN_PASSWORD || "vrfood-admin";

export const usingDemoAuth = !isSupabaseConfigured;

export async function signIn(email, password) {
  if (isSupabaseConfigured) {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw new Error(error.message);
    return;
  }
  if (password !== DEMO_PASSWORD) {
    throw new Error("Incorrect password.");
  }
  window.sessionStorage.setItem(DEMO_SESSION_KEY, "1");
}

export async function signOut() {
  if (isSupabaseConfigured) {
    await supabase.auth.signOut();
    return;
  }
  window.sessionStorage.removeItem(DEMO_SESSION_KEY);
}

export async function getSession() {
  if (isSupabaseConfigured) {
    const { data } = await supabase.auth.getSession();
    return data.session;
  }
  return window.sessionStorage.getItem(DEMO_SESSION_KEY) === "1" ? { demo: true } : null;
}

export function onAuthChange(callback) {
  if (isSupabaseConfigured) {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => {
      callback(session);
    });
    return () => data.subscription.unsubscribe();
  }
  // Demo mode has no external auth events; nothing to subscribe to.
  return () => {};
}
